module.exports = {
  TRANSACTIONAL: 'transactional',
  PROMOTIONAL: 'promotional',
};
